<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar-cha"><a id="file_009">
<h2 class="h2a"><strong><span class="smallcaps">CHAPTER ONE</span></strong></h2>
<p class="h2c"><strong>THE HELLCAT’S ORIGINS</strong></p>
</a></div><a id="file_009">
</a><div class="sidebar"><a id="file_009">
</a><p class="image"><a id="file_009"></a><a id="page_8"><img alt="Image" src="images/f0008-01.jpg"/></a></p><a id="page_8">
<p class="caption">A pair of sharp-looking Grumman F3F-3s patrol near the <em>Yorktown.</em> The planes flew in threes; the section leader has a completely red cowling and the number two man is flying above and to the left. The third man is shooting the photo. The distinctive “diving eagle” insignia of VF-5 is barely visible under the cockpit rail. <em>U.S. Navy via Stan Piet</em></p>
</a></div><a id="page_8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_009.vue?2762572a